import { render } from "./PracticeSwitchedModal.vue?vue&type=template&id=aa74f198"
import script from "./PracticeSwitchedModal.vue?vue&type=script&lang=js"
export * from "./PracticeSwitchedModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__